import React from "react";
import { Search, Video, Shield, FlaskConical, Package, Lock, Truck, ChevronRight } from "lucide-react";

const STEPS = [
  { icon: Search, label: "INSPECT" },
  { icon: Video, label: "DOCUMENT" },
  { icon: Shield, label: "PROTECT" },
  { icon: FlaskConical, label: "SERVICE" },
  { icon: Video, label: "DOCUMENT" },
  { icon: Package, label: "PACK" },
  { icon: Lock, label: "SEAL" },
  { icon: Truck, label: "TRACK" },
];

export const ChainOfCustody = () => (
  <div data-testid="chain-of-custody" className="rounded-2xl border border-[color:var(--line)] p-6 sm:p-8 bg-[color:var(--charcoal)]/40">
    <div className="flex flex-wrap items-center justify-center gap-y-6 gap-x-1">
      {STEPS.map((s, i) => (
        <React.Fragment key={i}>
          <div className="flex flex-col items-center gap-2 w-[74px]">
            <div className="h-12 w-12 rounded-full flex items-center justify-center holo-border">
              <s.icon size={19} className="text-[color:var(--cyan)]" />
            </div>
            <span className="font-tech text-[10px] tracking-widest text-[color:var(--chrome-2)]">{s.label}</span>
          </div>
          {i < STEPS.length - 1 && <ChevronRight size={16} className="text-[color:var(--chrome-3)] -mt-5" />}
        </React.Fragment>
      ))}
    </div>
    <p className="text-center text-xs text-[color:var(--chrome-3)] mt-6">
      Collectibles are treated as controlled submissions — not ordinary packages.
    </p>
  </div>
);
